import React, { useState } from 'react';
import './ServiceMultiSelect.css';

const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');

export default function ServiceMultiSelect({ services, selected, onChange, disabled = false }) {
  const [query, setQuery] = useState('');
  const selectedIds = selected.map(Number);
  const selectedServices = selectedIds.map((id) => services.find((service) => Number(service.id) === id)).filter(Boolean);
  const visibleServices = services.filter((service) => normalize(service.label).includes(normalize(query.trim())));
  const toggle = (id) => onChange(selectedIds.includes(id) ? selectedIds.filter((value) => value !== id) : [...selectedIds, id]);

  return <div className="service-multi-select">
    <span className="service-multi-label">Services affectés</span>
    <div className={`service-multi-selected${selectedServices.length ? ' has-selection' : ''}`} aria-live="polite">
      {selectedServices.length ? selectedServices.map((service, index) => <span className="service-multi-chip" key={service.id}>
        {service.label.replace(/^(-- )+/, '')}
        {index === 0 && <small>Par défaut</small>}
        <button type="button" aria-label={`Retirer ${service.label}`} disabled={disabled} onClick={() => toggle(Number(service.id))}>×</button>
      </span>) : <span className="service-multi-empty">Aucun service affecté</span>}
    </div>
    <details className="service-multi-choices">
      <summary>Choisir les services</summary>
      <div className="service-multi-panel">
        <input type="search" className="form-control" placeholder="Rechercher un service…" aria-label="Rechercher un service" value={query} disabled={disabled} onChange={(event) => setQuery(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') event.preventDefault(); }} />
        <div className="service-multi-options">
          {visibleServices.length ? visibleServices.map((service) => <label className="service-multi-option" key={service.id}>
            <input type="checkbox" checked={selectedIds.includes(Number(service.id))} disabled={disabled} onChange={() => toggle(Number(service.id))} />
            <span>{service.label}</span>
          </label>) : <span className="service-multi-no-results">Aucun service trouvé</span>}
        </div>
      </div>
    </details>
    <small className="service-multi-help">Sélectionnez un ou plusieurs services. Le premier sert de service par défaut.</small>
  </div>;
}
